"use strict";

var _defineProperty = require("/var/lib/jenkins/workspace/mr-learner-frontend-production/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var genCollapseMotion = function genCollapseMotion(token) {
  var _token$componentCls;

  return _defineProperty({}, token.componentCls, (_token$componentCls = {}, _defineProperty(_token$componentCls, "".concat(token.antCls, "-motion-collapse-legacy"), {
    overflow: 'hidden',
    '&-active': {
      transition: "height ".concat(token.motionDurationMid, " ").concat(token.motionEaseInOut, ",\n        opacity ").concat(token.motionDurationMid, " ").concat(token.motionEaseInOut, " !important")
    }
  }), _defineProperty(_token$componentCls, "".concat(token.antCls, "-motion-collapse"), {
    overflow: 'hidden',
    transition: "height ".concat(token.motionDurationMid, " ").concat(token.motionEaseInOut, ",\n        opacity ").concat(token.motionDurationMid, " ").concat(token.motionEaseInOut, " !important")
  }), _token$componentCls));
};

var _default = genCollapseMotion;
exports.default = _default;